<template>
  <el-dialog
    title="购卡记录"
    :visible.sync="dialog"
    width="40%">
     <el-table
      :data="list"
      style="width: 100%" v-loading="loading">
      <el-table-column
         prop="vippay_id"
         label="ID" width="80" align="center">
       </el-table-column>
       <el-table-column
          prop="pay_time"
          label="购卡时间" align="center">
        </el-table-column>
        <el-table-column
           prop="num"
           label="购卡数量"  align="center">
         </el-table-column>
         <el-table-column
            prop="price"
            label="支付金额"  align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
               <el-button type="success" size="small" @click="loogk(scope.row)">查看卡密</el-button>
            </template>
          </el-table-column>
      </el-table>

      <el-dialog title="查看卡密" width="50%" :visible.sync="kamilogo" append-to-body>
         <el-table
          :data="kaList"
          style="width: 100%" v-loading="loadings">
          <el-table-column
             prop="card_no"
             label="卡码"  align="center">
           </el-table-column>
           <el-table-column
              prop="card_password"
              label="卡密"  align="center">
            </el-table-column>
            <el-table-column label="激活状态" width="100" align="center">
              <template slot-scope="scope">
                 <span v-if="scope.row.active_status==1" style="color:red;">未激活</span>
                 <span v-if="scope.row.active_status==2">已激活</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
              <template slot-scope="scope">
                 <el-button type="success" size="mini" @click="cardActive(scope.row)" v-if="scope.row.active_status==1">
                   立即激活
                 </el-button>
              </template>
            </el-table-column>
         </el-table>
      </el-dialog>

  </el-dialog>
</template>

<script>
  import { Financial_Vippay_index,activeListNo,cardActive } from "@/api/gw/user"
  export default{
    data(){
      return{
        dialog:false,
        loading:false,
        list:[],

        kamilogo:false,
        kaList:[],
        loadings:false,
        vippay_id:""
      }
    },
    watch:{
       kamilogo(e){
         if(e==false){
           this.vippay_id = ''
           this.kaList = [];
         }
       },
       dialog(e){
         if(e==false){
           this.list = []
         }
       },
    },
    mounted(){
      this.Financial_Vippay_index();
    },
    methods:{
      show(){
        this.$nextTick(()=>{
          this.dialog = true
          this.Financial_Vippay_index();
        })
      },
      //查看卡密
      loogk(row){
        this.kamilogo = true
        this.loadings = true
        this.vippay_id = row.vippay_id
        activeListNo({
          vippay_id:this.vippay_id
        }).then(res=>{
          console.log("卡密",res.data);
          this.kaList = res.data
        }).finally(()=>{
          this.loadings = false
        })
      },
      //激活卡密
      cardActive(row){
          const loading = this.$loading({
            lock: true,
            text: '激活中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
         cardActive({
           card_no:row.card_no,
           card_password:row.card_password
         }).then(()=>{
           this.$message.success("激活成功");
           this.kamilogo = false
         }).finally(()=>{
           loading.close();
         })
      },
      //购卡记录
      Financial_Vippay_index(){
        this.loading = true
        Financial_Vippay_index(this.form).then(res=>{
          console.log("购卡记录",res.data);
          this.list = res.data
        }).finally(()=>{
          this.loading = false
        })
      },
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/home/components/son/gouka.vue